import * as types from '../types/suggestionTypes';

const initialState = {
  submitting: false,
  message: null,
  error: null,
};

export default function suggestionReducer(state = initialState, action) {
  switch (action.type) {
    case types.SUBMIT_SUGGESTION_REQUEST:
      return { ...state, submitting: true, message: null, error: null };
    case types.SUBMIT_SUGGESTION_SUCCESS:
      return { ...state, submitting: false, message: action.payload };
    case types.SUBMIT_SUGGESTION_FAILURE:
      return { ...state, submitting: false, error: action.payload };
    case types.SUGGESTION_RESET:
      return { ...initialState };
    default:
      return state;
  }
}
